module.exports = __webpack_public_path__ + "img/sunflower.3a481e43.png";